import Image from "next/image";
import { usePathname } from "next/navigation";
import { BashFace } from "@/components/bash-home/BashFace";
import { Button } from "@/components/ui/button";
import { HamburgerIcon } from "@/components/icons/HamburgerIcon";

const MobileHeader = ({ onOpenSideBar }: { onOpenSideBar: () => void }) => {
  const pathname = usePathname();

  return (
    <header className="flex md:hidden items-center justify-between px-3 md:px-6 min-h-(--site-header-height) bg-bg-subtle border-b border-border-subtle sticky top-0 z-1">
      <button
        className="flex items-center justify-center w-7 h-7 rounded-10 text-fg-muted transition-colors active:bg-bg-muted active:text-fg-default"
        aria-label="Open menu"
        onClick={onOpenSideBar}
      >
        <HamburgerIcon />
      </button>

      <div className="flex items-center gap-2">
        <Image
          src="/vestra.svg"
          alt=""
          width={20}
          height={20}
          className="rounded-4"
        />
        <span className="font-fauna font-[100] tracking-[0.04em] text-fg-default text-4 leading-none translate-y-0.5">
          VESTRA
        </span>
      </div>

      {pathname === "/home" ? (
        /* The Bash home's rail is a drawer on mobile; the copper face is its
               handle. Its styling rides bash-home.css, which BashHome imports —
               so the sheet is loaded exactly where this button renders. */
        <Button
          variant="unstyled"
          size="unstyled"
          className="w-10 h-10 rounded-10"
          onClick={() => window.dispatchEvent(new Event("toggle-home-rail"))}
          aria-label="Open the panel"
        >
          <BashFace size="sm" />
        </Button>
      ) : (
        <div className="w-[40px]" />
      )}
    </header>
  );
};

export default MobileHeader;
